module.exports = __webpack_public_path__ + "static/construction-project-management-aerial-photography-2d101bc5030580402dc0e23502f0c193.jpg";